  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>email</mat-icon></span>  
    <p>Send Email</p>   
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
    
  </h2>

<mat-dialog-content>
 
  <div *ngIf="disabledEmailNotification == true" style="color: red;">
    To enable the Email Action feature, configure your custom SMTP settings in the Admin section. Navigate to the Organization tab, then select Mail to enter the required SMTP details.
  </div>

  <mat-form-field class="example-full-width">
    <mat-label>To</mat-label>
    <input matInput maxlength="100" [required]="true"  placeholder="Add recipients"
       [(ngModel)]="recipients"/>      
  </mat-form-field>

  <mat-form-field class="mulDropdown" appearance="">
    <mat-select placeholder="Select Email Template" (selectionChange)="OnSelectTemplate($event)">
      <mat-option *ngFor="let stat of emailTemplateList" [value]="stat.emailTemplateID">
        {{ stat.emailTemplateName }}
     </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="example-full-width">
    <mat-label>Subject</mat-label>
    <input matInput maxlength="100" [required]="true"  
     placeholder="add subject"  [(ngModel)]="subject"
      />      
</mat-form-field>
<br>
<br>
  <div>
    <mat-label>Message</mat-label>
    <ng-container>
      <ckeditor  [(ngModel)]="msg"  [config]="editorConfig"
        editorUrl="https://cdn.ckeditor.com/4.14.0/full/ckeditor.js">
      </ckeditor>
    </ng-container>
  </div>

 </mat-dialog-content>
  
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" 
      (click)="SaveEmailAction()" color="primary" [disabled]="disabledEmailNotification == true">
      <mat-icon *ngIf="spinner">
        <mat-spinner diameter="20">
      </mat-spinner>
    </mat-icon>
      Send
    </button>  
   
  </mat-dialog-actions>


  <app-loader></app-loader>

  <style>
    .cke_notifications_area { display: none;}
  </style>
  
  <style>
    .cke_notification { display: none; }
  </style>
  <style>
    .cke_notification_warning { display: none; }
  </style>


  

  




